import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";

const styles = {
  tooltip: {
    marginTop: "0px",
    fontSize: "1em",
    fontWeight: "400",
  },
};

const EllipsedText = (props) => {
  const { classes, text, maxLength } = props;

  if (text && text.length > maxLength) {
    return (
      <Tooltip
        title={text}
        placement="bottom"
        classes={{ tooltip: classes.tooltip }}
      >
        <Box component="span">{`${text.substring(0, maxLength - 1)}...`}</Box>
      </Tooltip>
    );
  }

  return <Box component="span">{text}</Box>;
};

EllipsedText.propTypes = {
  text: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
};

export default withStyles(styles)(EllipsedText);
